<template>
    <div class="card-circle center-content border">
        <div class="anim-container d-flex p-5">
            <Flask class="m-3" />
            <Vial class="m-3" />
        </div>

        <div class="loader-icon-container center-content">
            <span
                class="fa-thin fa-spinner-third fa-spin text-primary"
                style="font-size: 300px"
            ></span>
        </div>
    </div>
</template>

<style scoped>
@keyframes fade {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.loader-icon-container {
    width: 300px;
    height: 300px;
    position: fixed;
}

.center-content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
}

.card-circle {
    background-color: #f8fafc;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
    position: relative;
}

.card-circle::before {
    content: "";
    position: absolute;
    height: 300px;
    width: 300px;
    border-radius: 50%;
    border: 10px red;
}
</style>

<script>
import Flask from "@components/Flask.vue";
import Vial from "@components/Vial.vue";

export default {
    name: "LoadAnimation",
    components: { Flask, Vial },
};
</script>
